// core/wa-kantor — nomor WA TUJUAN INTERNAL per cabang (keputusan Apo 20 Jul).
//
// Aturannya: pesan internal TIDAK dikirim ke nomor pribadi orangnya, melainkan ke NOMOR KANTOR
// per cabang (mis. HP counter CS, HP bengkel, HP finance). Satu peran boleh punya lebih dari satu
// nomor; bila lebih dari satu, staf memilih tujuan sebelum mengirim.
//
// Kenapa bukan nomor pribadi: staf berganti, nomor pribadi berubah, dan pesan kerja tak seharusnya
// menempel ke orangnya. Nomor kantor tetap walau orangnya berganti shift.
import { getSetting, saveSetting } from './settings';
import { openWA } from './wa';
import { openModal } from '@ui/modal';
import { esc } from '@domain/format';

export type PeranWa = 'cs' | 'teknisi' | 'finance';
export interface NomorKantor { label: string; wa: string }
/** { [kodeCabang]: { cs: [...], teknisi: [...], finance: [...] } } */
export type WaKantor = Record<string, Partial<Record<PeranWa, NomorKantor[]>>>;

export const PERAN_WA: { k: PeranWa; label: string; contoh: string }[] = [
  { k: 'cs', label: '🎧 CS / Counter', contoh: 'HP counter depan' },
  { k: 'teknisi', label: '🔧 Teknisi / Bengkel', contoh: 'HP meja teknisi' },
  { k: 'finance', label: '💰 Finance / Kasir', contoh: 'HP kasir' },
];

export const waKantor = (): WaKantor => getSetting<WaKantor>('wa_kantor', {});
export const saveWaKantor = (v: WaKantor): Promise<void> => saveSetting('wa_kantor', v);

/** Nomor tujuan utk satu peran di satu cabang (kosong = belum diatur di Pengaturan). */
export function nomorUntuk(outlet: string | null, peran: PeranWa): NomorKantor[] {
  const perCabang = waKantor()[outlet ?? ''] ?? {};
  return (perCabang[peran] ?? []).filter((n) => (n.wa ?? '').replace(/\D/g, '').length >= 8);
}

/**
 * Kirim pesan internal ke nomor kantor. 0 nomor → beri tahu cara mengaturnya (jangan diam);
 * 1 nomor → langsung kirim; >1 → tampilkan pilihan dulu (permintaan Apo).
 */
export function kirimKeKantor(outlet: string | null, peran: PeranWa, pesan: string, onInfo?: (m: string) => void): void {
  const daftar = nomorUntuk(outlet, peran);
  const namaPeran = PERAN_WA.find((p) => p.k === peran)?.label ?? peran;
  if (!daftar.length) {
    onInfo?.(`Nomor WA ${namaPeran} untuk cabang ${outlet ?? '—'} belum diatur. Isi di Pengaturan → 📄 Dokumen & Template → 📱 Nomor WA Kantor.`);
    return;
  }
  if (daftar.length === 1) { openWA(daftar[0]!.wa, pesan); return; }
  const bg = openModal(`<div class="modal-head"><h3>💬 Kirim ke ${esc(namaPeran)}</h3><button class="x">×</button></div>
    <div class="modal-body">
      <div class="scope-note">Cabang <b>${esc(outlet ?? '—')}</b> punya ${daftar.length} nomor. Pilih tujuannya:</div>
      ${daftar.map((n, i) => `<button class="btn" data-pilih="${i}" style="display:block;width:100%;text-align:left;margin:6px 0;padding:9px 12px">
          <b>${esc(n.label || 'Tanpa label')}</b><br><span style="font-size:12px;color:var(--muted)">${esc(n.wa)}</span></button>`).join('')}
    </div><div class="modal-foot"><button class="btn" id="wk_batal">Batal</button></div>`);
  bg.querySelector('#wk_batal')?.addEventListener('click', () => bg.remove());
  bg.querySelectorAll<HTMLElement>('button[data-pilih]').forEach((b) => b.addEventListener('click', () => {
    const n = daftar[+(b.dataset['pilih'] ?? 0)];
    bg.remove();
    if (n) openWA(n.wa, pesan);
  }));
}
